export default __webpack_public_path__ + "static/media/discord.7e463c75.svg";